module.exports = __webpack_public_path__ + "img/bg-5.48c15570.jpg";